import { getCookie } from "helpers/common";

const API_BASE = process.env.NEXT_PUBLIC_API_BASE || process.env.REACT_APP_BUSINESS_MANAGEMENT_URL || "";

async function request(path, { method = "GET", body, headers = {} } = {}) {
    const token = getCookie(process.env.REACT_APP_FOODIE_TOKEN_COOKIE);
    const mergedHeaders = {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        ...headers,
    };

    const res = await fetch(`${API_BASE}${path}`, {
        method,
        headers: mergedHeaders,
        body: body ? JSON.stringify(body) : undefined,
    });

    const isJson = res.headers.get("content-type")?.includes("application/json");
    const data = isJson ? await res.json() : undefined;

    if (!res.ok) {
        const message = data?.message || data?.error || res.statusText || "Request failed";
        throw new Error(message);
    }

    return data;
}

export const apiClient = {
    get: (path) => request(path, { method: "GET" }),
    post: (path, body) => request(path, { method: "POST", body }),
    del: (path) => request(path, { method: "DELETE" }),
    put: (path, body) => request(path, { method: "PUT", body }),
    patch: (path, body) => request(path, { method: "PATCH", body }),
}; 